import type { AasApiAdapter } from "../adapter";
import { requestJson } from "../http";
import type { AgentDeployment, PromoteDeploymentResult } from "../types";

export const deploymentsApi: AasApiAdapter["deployments"] = {
	async list(slug) {
		return requestJson<AgentDeployment[]>(`/api/agents/${encodeURIComponent(slug)}/deployments`);
	},
	async promote(slug, id) {
		const result = await requestJson<{ warnings?: string[] }>(
			`/api/agents/${encodeURIComponent(slug)}/deployments/${encodeURIComponent(id)}/promote`,
			{ method: "POST" },
		);
		return { warnings: result.warnings ?? [] } satisfies PromoteDeploymentResult;
	},
};
